import { CalculationLineApi } from "../types";

declare type CategorizedLineItemsDict = {
    [category: string]: {
        [lineName: string]: {
            items: Partial<CalculationLineApi>[]
        }
    }
};

export const CATEGORIZED_LINE_ITEMS: CategorizedLineItemsDict =
{
    "05 Loodsen en keten": {
        "Huur bio box / bouwtoilet": {
            "items": [
                {
                    "sortOrder": 1,
                    "code": "05.31",
                    "description": "Huur bio box / bouwtoilet",
                    "unit": "wkn",
                    "equipment": {
                        "norm": 50
                    }
                }
            ]
        },
        "Transport aan- en afvoer bio box": {
            "items": [
                {
                    "sortOrder": 2,
                    "code": "05.31",
                    "description": "Transport aan- en afvoer bio box",
                    "unit": "pst",
                    "equipment": {
                        "norm": 80
                    }
                }
            ]
        },
        "Huur brede rolsteiger (tot max werkhoogte 4,2m)": {
            "items": [
                {
                    "sortOrder": 3,
                    "code": "05.32",
                    "description": "Huur brede rolsteiger (tot max werkhoogte 4,2m)",
                    "unit": "wkn",
                    "equipment": {
                        "norm": 98
                    }
                }
            ]
        },
        "Transport aan- en afvoer rolsteiger": {
            "items": [
                {
                    "sortOrder": 4,
                    "code": "05.32",
                    "description": "Transport aan- en afvoer rolsteiger",
                    "unit": "pst",
                    "equipment": {
                        "norm": 80
                    }
                }
            ]
        },
        "Inzet / huur schaarhoogwerker": {
            "items": [
                {
                    "sortOrder": 5,
                    "code": "05.32",
                    "description": "Inzet / huur schaarhoogwerker",
                    "unit": "wkn",
                    "equipment": {
                        "norm": 350
                    }
                }
            ]
        },
        "Transport aan- en afvoer schaarhoogwerker": {
            "items": [
                {
                    "sortOrder": 6,
                    "code": "05.32",
                    "description": "Transport aan- en afvoer schaarhoogwerker",
                    "unit": "pst",
                    "equipment": {
                        "norm": 160
                    }
                }
            ]
        },
        "Huur bouwverwarming 9kW": {
            "items": [
                {
                    "sortOrder": 7,
                    "code": "05.32",
                    "description": "Huur bouwverwarming 9kW",
                    "unit": "wkn",
                    "equipment": {
                        "norm": 90
                    }
                }
            ]
        },
        "Transport aan- en afvoer bouwverwarming": {
            "items": [
                {
                    "sortOrder": 8,
                    "code": "05.32",
                    "description": "Transport aan- en afvoer bouwverwarming",
                    "unit": "pst",
                    "equipment": {
                        "norm": 80
                    }
                }
            ]
        },
        "Inzet / Huur E verdeelkast / Haspels": {
            "items": [
                {
                    "sortOrder": 9,
                    "code": "05.32",
                    "description": "Huur E verdeelkast",
                    "unit": "wkn",
                    "equipment": {
                        "norm": 40
                    }
                }
            ]
        },
        "Huur E Kabels 230V 2stk": {
            "items": [
                {
                    "sortOrder": 10,
                    "code": "05.32",
                    "description": "Huur Kabel 230V 2stk",
                    "unit": "wkn",
                    "equipment": {
                        "norm": 15
                    }
                }
            ]
        },
        "Huur bouwverlichting 1000W/230V 2stk": {
            "items": [
                {
                    "sortOrder": 11,
                    "code": "05.32",
                    "description": "Huur bouwverlichting 1000W/230V 2stk",
                    "unit": "wkn",
                    "equipment": {
                        "norm": 60
                    }
                }
            ]
        },
        "Eindschoonmaak inclusief nat afdoen binnenbeglazing": {
            "items": [
                {
                    "sortOrder": 12,
                    "code": "05.34",
                    "description": "Eindschoonmaak inclusief nat afdoen binnenbeglazing",
                    "unit": "m2",
                    "equipment": {
                        "norm": 4
                    }
                }
            ]
        },
        "Eindschoonmaak / bezemschoon opleveren": {
            "items": [
                {
                    "sortOrder": 13,
                    "code": "05.34",
                    "description": "Eindschoonmaak / bezemschoon opleveren",
                    "unit": "m2",
                    "equipment": {
                        "norm": 3
                    }
                }
            ]
        },
        "6m3 BSA afvalcontainer": {
            "items": [
                {
                    "sortOrder": 14,
                    "code": "05.41",
                    "description": "6m3 BSA afvalcontainers",
                    "unit": "stk",
                    "subcontracting": {
                        "norm": 285
                    }
                }
            ]
        },
        "10m3 BSA afvalcontainer ": {
            "items": [
                {
                    "sortOrder": 15,
                    "code": "05.41",
                    "description": "10m3 BSA afvalcontainer ",
                    "unit": "stk",
                    "subcontracting": {
                        "norm": 360
                    }
                }
            ]
        }
    },
    "10 Stut- en Sloopwerk": {
        "Verwijderen systeemplafond": {
            "items": [
                {
                    "sortOrder": 1,
                    "code": "10.32",
                    "description": "Verwijderen systeemplafond",
                    "unit": "m2",
                    "hours": {
                        "norm": 0.12
                    }
                }
            ]
        },
        "Verwijderen gipsplafond": {
            "items": [
                {
                    "sortOrder": 2,
                    "code": "10.32",
                    "description": "Verwijderen gipsplafond",
                    "unit": "m2",
                    "hours": {
                        "norm": 0.15
                    }
                }
            ]
        },
        "Verwijderen tegelvloer gelijmd": {
            "items": [
                {
                    "sortOrder": 3,
                    "code": "10.32",
                    "description": "Verwijderen tegelvloer gelijmd",
                    "unit": "m2",
                    "hours": {
                        "norm": 0.2
                    }
                }
            ]
        },
        "Verwijderen pvc vloer gelijmd": {
            "items": [
                {
                    "sortOrder": 4,
                    "code": "10.32",
                    "description": "Verwijderen pvc vloer",
                    "unit": "m2",
                    "hours": {
                        "norm": 0.12
                    }
                }
            ]
        },
        "Verwijderen vloerbedekking gelijmd": {
            "items": [
                {
                    "sortOrder": 5,
                    "code": "10.32",
                    "description": "Verwijderen vloerbedekking",
                    "unit": "m2",
                    "hours": {
                        "norm": 0.1
                    }
                }
            ]
        },
        "Verwijderen CD dekvloer (tot 10cm)": {
            "items": [
                {
                    "sortOrder": 6,
                    "code": "10.32",
                    "description": "Verwijderen CD dekvloer (tot 10cm)",
                    "unit": "m2",
                    "hours": {
                        "norm": 0.3
                    }
                }
            ]
        },
        "Verwijderen lichte scheidingswanden": {
            "items": [
                {
                    "sortOrder": 7,
                    "code": "10.32",
                    "description": "Verwijderen lichte scheidingswanden",
                    "unit": "m2",
                    "hours": {
                        "norm": 0.3
                    }
                }
            ]
        },
        "Verwijderen glaswanden en deuren": {
            "items": [
                {
                    "sortOrder": 8,
                    "code": "10.32",
                    "description": "Verwijderen glaswanden en deuren",
                    "unit": "m2",
                    "hours": {
                        "norm": 0.4
                    }
                }
            ]
        },
        "Verwijderen steens wanden": {
            "items": [
                {
                    "sortOrder": 9,
                    "code": "10.32",
                    "description": "Verwijderen steens wanden",
                    "unit": "m2",
                    "hours": {
                        "norm": 0.4
                    }
                }
            ]
        },
        "Verwijderen pantry": {
            "items": [
                {
                    "sortOrder": 10,
                    "code": "10.32",
                    "description": "Verwijderen pantry",
                    "unit": "stk",
                    "hours": {
                        "norm": 6
                    }
                }
            ]
        }
    },
    "24 Ruwbouwtimmerwerk": {
        "Balklaag (71x171)": {
            "items": [
                {
                    "sortOrder": 2,
                    "code": "24.31",
                    "description": "Balklaag (71x171) h.o.h. 400mm",
                    "unit": "m1",
                    "hours": {
                        "norm": 0.35
                    },
                    "material": {
                        "norm": 6
                    }
                }
            ]
        },
        "Balklaag (95x195)": {
            "items": [
                {
                    "sortOrder": 3,
                    "code": "24.31",
                    "description": "Balklaag (95x195) h.o.h. 600mm",
                    "unit": "m1",
                    "hours": {
                        "norm": 0.4
                    },
                    "material": {
                        "norm": 10
                    }
                }
            ]
        },
        "Enkel vloerbeschot": {
            "items": [
                {
                    "sortOrder": 4,
                    "code": "24.31",
                    "description": "Enkel vloerbeschot",
                    "unit": "m2",
                    "hours": {
                        "norm": 0.4
                    },
                    "material": {
                        "norm": 10
                    }
                }
            ]
        },
        "Dubbel vloerbeschot": {
            "items": [
                {
                    "sortOrder": 5,
                    "code": "24.31",
                    "description": "Dubbel vloerbeschot",
                    "unit": "m2",
                    "hours": {
                        "norm": 0.6
                    },
                    "material": {
                        "norm": 20
                    }
                }
            ]
        }
    },
    "30 Kozijnen, ramen en deuren": {
        "Stelkozijn": {
            "items": [
                {
                    "sortOrder": 1,
                    "code": "30.31",
                    "description": "Gemodificeerd stelkozijn ",
                    "unit": "m1",
                    "hours": {
                        "norm": 0.4
                    },
                    "material": {
                        "norm": 15
                    }
                },
                {
                    "sortOrder": 2,
                    "code": "30.31",
                    "description": "- 22mm WBP Multiplex"
                }
            ]
        },
        "Hardhouten binnendeurkozijn 56*115": {
            "items": [
                {
                    "sortOrder": 3,
                    "code": "30.32",
                    "description": "Hardhouten binnendeurkozijn (stomp) ",
                    "unit": "stk",
                    "hours": {
                        "norm": 2.5
                    },
                    "material": {
                        "norm": 70
                    }
                },
                {
                    "sortOrder": 4,
                    "code": "30.32",
                    "description": "- Kozijnpakket 56x115x2315"
                }
            ]
        },
        "Hardhouten binnendeurkozijn 56*90": {
            "items": [
                {
                    "sortOrder": 5,
                    "code": "30.32",
                    "description": "Hardhouten binnendeurkozijn (stomp) ",
                    "unit": "stk",
                    "hours": {
                        "norm": 2.5
                    },
                    "material": {
                        "norm": 50
                    }
                },
                {
                    "sortOrder": 6,
                    "code": "30.32",
                    "description": "- Kozijnpakket 56x90x2315"
                }
            ]
        },
        "Hardhouten binnendeurkozijn 67x114": {
            "items": [
                {
                    "sortOrder": 7,
                    "code": "30.32",
                    "description": "Hardhouten binnendeurkozijn (stomp) ",
                    "unit": "stk",
                    "hours": {
                        "norm": 1
                    },
                    "material": {
                        "norm": 185
                    }
                },
                {
                    "sortOrder": 8,
                    "code": "30.32",
                    "description": "- Standaard hardhouten binnendeurkozijn "
                }
            ]
        },
        "Hardhouten binnendeurkozijn 67x114 (BW)": {
            "items": [
                {
                    "sortOrder": 9,
                    "code": "30.32",
                    "description": "Hardhouten binnendeurkozijn (stomp) met 25mm sponning",
                    "unit": "stk",
                    "hours": {
                        "norm": 1
                    },
                    "material": {
                        "norm": 240
                    }
                },
                {
                    "sortOrder": 10,
                    "code": "30.32",
                    "description": "- Verdiepte 25mm sponning hardhouten binnendeurkozijn "
                }
            ]
        },
        "Honinggraat schilder binnendeur (930x2315)": {
            "items": [
                {
                    "sortOrder": 11,
                    "code": "30.33",
                    "description": "Honinggraat schilder binnendeur (930x2315)",
                    "unit": "stk",
                    "hours": {
                        "norm": 3
                    },
                    "material": {
                        "norm": 80
                    }
                },
                {
                    "sortOrder": 12,
                    "code": "30.33",
                    "description": "- standaard honinggraat binnndeur in het werk afgehangen 930x2315"
                }
            ]
        },
        "Honinggraat schilder binnendeur (930x2115)": {
            "items": [
                {
                    "sortOrder": 13,
                    "code": "30.33",
                    "description": "Honinggraat schilder binnendeur (930x2115)",
                    "unit": "stk",
                    "hours": {
                        "norm": 3
                    },
                    "material": {
                        "norm": 70
                    }
                },
                {
                    "sortOrder": 14,
                    "code": "30.33",
                    "description": "- standaard honinggraat binnndeur in het werk afgehangen 930x2115"
                }
            ]
        },
        "Volspaan schilder binnendeur (930x2315)": {
            "items": [
                {
                    "sortOrder": 15,
                    "code": "30.33",
                    "description": "Volspaan binnendeur (930x2315)",
                    "unit": "stk",
                    "hours": {
                        "norm": 3
                    },
                    "material": {
                        "norm": 115
                    }
                },
                {
                    "sortOrder": 16,
                    "code": "30.33",
                    "description": "- standaard volspaan binnndeur in het werk afgehangen 930x2315"
                }
            ]
        },
        "Volspaan schilder binnendeur (930x2115)": {
            "items": [
                {
                    "sortOrder": 17,
                    "code": "30.33",
                    "description": "Volspaan binnendeur (930x2115)",
                    "unit": "stk",
                    "hours": {
                        "norm": 3
                    },
                    "material": {
                        "norm": 100
                    }
                },
                {
                    "sortOrder": 18,
                    "code": "30.33",
                    "description": "- standaard volspaan binnndeur in het werk afgehangen 930x2115"
                }
            ]
        },
        "Standaard volspaan HPL binnendeur (930x2315)": {
            "items": [
                {
                    "sortOrder": 19,
                    "code": "30.33",
                    "description": "Standaard HPL binnendeur (930x2315)",
                    "unit": "stk",
                    "hours": {
                        "norm": 3
                    },
                    "material": {
                        "norm": 285
                    }
                },
                {
                    "sortOrder": 20,
                    "code": "30.33",
                    "description": "- standaard HPL binnndeur in het werk afgehangen 930x2315"
                }
            ]
        },
        "Standaard volspaan HPL binnendeur (880x2315)": {
            "items": [
                {
                    "sortOrder": 21,
                    "code": "30.33",
                    "description": "Standaard HPL binnendeur (880x2315)",
                    "unit": "stk",
                    "hours": {
                        "norm": 3
                    },
                    "material": {
                        "norm": 265
                    }
                },
                {
                    "sortOrder": 22,
                    "code": "30.33",
                    "description": "- standaard HPL binnndeur in het werk afgehangen 880x2315"
                }
            ]
        },
        "Standaard volspaan HPL binnendeur (830x2315)": {
            "items": [
                {
                    "sortOrder": 23,
                    "code": "30.33",
                    "description": "Standaard HPL binnendeur (830x2315)",
                    "unit": "stk",
                    "hours": {
                        "norm": 3
                    },
                    "material": {
                        "norm": 245
                    }
                },
                {
                    "sortOrder": 24,
                    "code": "30.33",
                    "description": "- standaard HPL binnndeur in het werk afgehangen 830x23115"
                }
            ]
        },
        "60min HPL binnendeur (930x2315)": {
            "items": [
                {
                    "sortOrder": 25,
                    "code": "30.33",
                    "description": "Brandwerende HPL binnendeur (930x2315)",
                    "unit": "stk",
                    "hours": {
                        "norm": 3
                    },
                    "material": {
                        "norm": 450
                    }
                },
                {
                    "sortOrder": 26,
                    "code": "30.33",
                    "description": "- Brandwerende HPL binnendeur 930x2315"
                }
            ]
        },
        "60min Volspaan binnendeur (930x2315)": {
            "items": [
                {
                    "sortOrder": 27,
                    "code": "30.33",
                    "description": "Brandwerende Volspaan binnendeur (930x2315)",
                    "unit": "stk",
                    "hours": {
                        "norm": 3
                    },
                    "material": {
                        "norm": 350
                    }
                },
                {
                    "sortOrder": 28,
                    "code": "30.33",
                    "description": "- Brandwerende volspaan schilder binnendeur 930x2315"
                }
            ]
        },
        "Volglazen systeemwand (glas flush)": {
            "items": [
                {
                    "sortOrder": 29,
                    "code": "30.52",
                    "description": "Volglazen systeemwand (glas flush)",
                    "unit": "m2",
                    "subcontracting": {
                        "norm": 225
                    }
                }
            ]
        },
        "Volglazen standaard glasdeur": {
            "items": [
                {
                    "sortOrder": 30,
                    "code": "30.52",
                    "description": "Volglazen standaard glasdeur",
                    "unit": "stk",
                    "subcontracting": {
                        "norm": 300
                    }
                }
            ]
        },
        "Volglazen systeemwand (hoogwaardig akoestisch)": {
            "items": [
                {
                    "sortOrder": 31,
                    "code": "30.52",
                    "description": "Volglazen systeemwand (hoogwaardig akoestisch)",
                    "unit": "m2",
                    "subcontracting": {
                        "norm": 350
                    }
                }
            ]
        },
        "Volglazen kaderdeur met valdorpel": {
            "items": [
                {
                    "sortOrder": 32,
                    "code": "30.52",
                    "description": "Volglazen kaderdeur met valdorpel in glaswand",
                    "unit": "stk",
                    "subcontracting": {
                        "norm": 500
                    }
                }
            ]
        },
        "Binnendeurbeslag Hoppe A'dam DN cilinderslot ": {
            "items": [
                {
                    "sortOrder": 33,
                    "code": "30.80",
                    "description": "Binnendeur met met Hoppe A'dam DN cilinderslot",
                    "unit": "stk",
                    "hours": {
                        "norm": 1
                    },
                    "material": {
                        "norm": 90
                    }
                }
            ]
        },
        "Binnendeurbeslag Hoppe A'dam Vrij- bezet slot": {
            "items": [
                {
                    "sortOrder": 34,
                    "code": "30.80",
                    "description": "Binnendeurbeslag Hoppe A'dam Vrij- bezet slot",
                    "unit": "stk",
                    "hours": {
                        "norm": 1
                    },
                    "material": {
                        "norm": 75
                    }
                }
            ]
        },
        "Binnendeurbeslag Hoppe A'dam Loopslot": {
            "items": [
                {
                    "sortOrder": 35,
                    "code": "30.80",
                    "description": "Binnendeurbeslag Hoppe A'dam Loopslot",
                    "unit": "stk",
                    "hours": {
                        "norm": 1
                    },
                    "material": {
                        "norm": 60
                    }
                }
            ]
        },
        "Deurstopper": {
            "items": [
                {
                    "sortOrder": 36,
                    "code": "30.80",
                    "description": "Deurstopper",
                    "unit": "stk",
                    "hours": {
                        "norm": 0.5
                    },
                    "material": {
                        "norm": 7.5
                    }
                }
            ]
        },
        "Deurdranger TS90": {
            "items": [
                {
                    "sortOrder": 37,
                    "code": "30.80",
                    "description": "Deurdranger TS90",
                    "unit": "stk",
                    "hours": {
                        "norm": 1.5
                    },
                    "material": {
                        "norm": 125
                    }
                }
            ]
        },
        "Deurdranger TS98": {
            "items": [
                {
                    "sortOrder": 38,
                    "code": "30.80",
                    "description": "Deurdranger TS98",
                    "unit": "stk",
                    "hours": {
                        "norm": 1.5
                    },
                    "material": {
                        "norm": 300
                    }
                }
            ]
        },
        "Maasland codeslot": {
            "items": [
                {
                    "sortOrder": 39,
                    "code": "30.80",
                    "description": "Maasland codeslot",
                    "unit": "stk",
                    "hours": {
                        "norm": 1.5
                    },
                    "material": {
                        "norm": 110
                    }
                }
            ]
        },
        "Tongnaald tbv dubbele deur": {
            "items": [
                {
                    "sortOrder": 40,
                    "code": "30.80",
                    "description": "Tongnaald",
                    "unit": "stk",
                    "hours": {
                        "norm": 1.5
                    },
                    "material": {
                        "norm": 80
                    }
                }
            ]
        },
        "Kantschuif onderaansluiting dubbele deur": {
            "items": [
                {
                    "sortOrder": 41,
                    "code": "30.80",
                    "description": "Kantschuif inclusief vloeroog",
                    "unit": "stk",
                    "hours": {
                        "norm": 1
                    },
                    "material": {
                        "norm": 40
                    }
                }
            ]
        }
    },
    "40 Stukadoorswerk": {
        "Wanden afmessen klasse B": {
            "items": [
                {
                    "sortOrder": 1,
                    "code": "40.40",
                    "description": "Wanden afmessen klasse B",
                    "unit": "m2",
                    "subcontracting": {
                        "norm": 9
                    }
                }
            ]
        },
        "Wanden afmessen klasse A": {
            "items": [
                {
                    "sortOrder": 2,
                    "code": "40.40",
                    "description": "Wanden afmessen klasse A",
                    "unit": "m2",
                    "subcontracting": {
                        "norm": 19
                    }
                }
            ]
        },
        "Plafonds afmessen klasse B [enkel basis gipsplafond 4AK]": {
            "items": [
                {
                    "sortOrder": 3,
                    "code": "40.40",
                    "description": "Plafonds afmessen klasse B [enkel basis gipsplafond 4AK]",
                    "unit": "m2",
                    "subcontracting": {
                        "norm": 10
                    }
                }
            ]
        },
        "Plafonds afmessen klasse A  [dubbel basis gipsplafond 4AK]": {
            "items": [
                {
                    "sortOrder": 4,
                    "code": "40.40",
                    "description": "Plafonds afmessen klasse A  [dubbel basis gipsplafond 4AK]",
                    "unit": "m2",
                    "subcontracting": {
                        "norm": 22
                    }
                }
            ]
        },
        "Stucwerk op steens wanden [raabwerk]": {
            "items": [
                {
                    "sortOrder": 5,
                    "code": "40.40",
                    "description": "Stucwerk op steens wanden [raabwerk]",
                    "unit": "m2",
                    "subcontracting": {
                        "norm": 27
                    }
                }
            ]
        },
        "Stucwerk op kalkzandsteen wanden": {
            "items": [
                {
                    "sortOrder": 6,
                    "code": "40.40",
                    "description": "Stucwerk op kalkzandsteen wanden",
                    "unit": "m2",
                    "subcontracting": {
                        "norm": 22
                    }
                }
            ]
        },
        "Flexcorners ": {
            "items": [
                {
                    "sortOrder": 7,
                    "code": "40.40",
                    "description": "Flexcorners tbv uitwendige hoeken",
                    "unit": "m1",
                    "subcontracting": {
                        "norm": 9
                    }
                }
            ]
        },
        "Stucprofielen / eindprofielen": {
            "items": [
                {
                    "sortOrder": 8,
                    "code": "40.40",
                    "description": "Alu Stuc hoek en/of eindprofielen",
                    "unit": "m1",
                    "subcontracting": {
                        "norm": 12
                    }
                }
            ]
        }
    },
    "41 Tegelwerk": {
        "Aanbrengen wandtegels 300x300 tot 600x600": {
            "items": [
                {
                    "sortOrder": 1,
                    "code": "41.32",
                    "description": "Aanbrengen wandtegels 300x300 tot 600x600 incl. primer, lijm en voeg",
                    "unit": "m2",
                    "subcontracting": {
                        "norm": 50
                    }
                }
            ]
        },
        "Aanbrengen wandtegels 750x750 tot 1000x1000": {
            "items": [
                {
                    "sortOrder": 2,
                    "code": "41.32",
                    "description": "Aanbrengen wandtegels 750x750 tot 1000x1000 incl. primer, lijm en voeg",
                    "unit": "m2",
                    "subcontracting": {
                        "norm": 60
                    }
                }
            ]
        },
        "Aanbrengen wandtegels 600x1200 tot 1200x1200": {
            "items": [
                {
                    "sortOrder": 3,
                    "code": "41.32",
                    "description": "Aanbrengen wandtegels 600x1200 tot 1200x1200 incl. primer, lijm en voeg",
                    "unit": "m2",
                    "subcontracting": {
                        "norm": 65
                    }
                }
            ]
        },
        "Aanbrengen wandtegels toeslag visgraat of speciaal motief": {
            "items": [
                {
                    "sortOrder": 4,
                    "code": "41.32",
                    "description": "Aanbrengen wandtegels toeslag visgraat of speciaal motief",
                    "unit": "m2",
                    "subcontracting": {
                        "norm": 15
                    }
                }
            ]
        },
        "Aanbrengen vloertegels 300x300 tot 600x600": {
            "items": [
                {
                    "sortOrder": 5,
                    "code": "41.42",
                    "description": "Aanbrengen vloertegels 300x300 tot 600x600 incl. primer, lijm en voeg",
                    "unit": "m2",
                    "subcontracting": {
                        "norm": 50
                    }
                }
            ]
        },
        "Aanbrengen vloertegels 750x750 tot 1000x1000": {
            "items": [
                {
                    "sortOrder": 6,
                    "code": "41.42",
                    "description": "Aanbrengen vloertegels 750x750 tot 1000x1000 incl. primer, lijm en voeg",
                    "unit": "m2",
                    "subcontracting": {
                        "norm": 55
                    }
                }
            ]
        },
        "Aanbrengen vloertegels 600x1200 tot 1200x1200": {
            "items": [
                {
                    "sortOrder": 7,
                    "code": "41.42",
                    "description": "Aanbrengen vloertegels 600x1200 tot 1200x1200 incl. primer, lijm en voeg",
                    "unit": "m2",
                    "subcontracting": {
                        "norm": 60
                    }
                }
            ]
        },
        "Aanbrengen vloertegels toeslag visgraat of speciaal motief": {
            "items": [
                {
                    "sortOrder": 8,
                    "code": "41.42",
                    "description": "Aanbrengen vloertegels toeslag visgraat of speciaal motief",
                    "unit": "m2",
                    "subcontracting": {
                        "norm": 15
                    }
                }
            ]
        },
        "Alu tegelprofielen": {
            "items": [
                {
                    "sortOrder": 9,
                    "code": "41.80",
                    "description": "Alu tegelprofielen",
                    "unit": "m1",
                    "subcontracting": {
                        "norm": 15
                    }
                }
            ]
        },
        "RVS tegelprofielen": {
            "items": [
                {
                    "sortOrder": 10,
                    "code": "41.80",
                    "description": "RVS tegelprofielen",
                    "unit": "m1",
                    "subcontracting": {
                        "norm": 25
                    }
                }
            ]
        }
    },
    "42 Dekvloeren en vloersystemen": {
        "ZCD 10cm inclusief droogtijdversneller": {
            "items": [
                {
                    "sortOrder": 1,
                    "code": "42.50",
                    "description": "ZCD 10cm inclusief droogtijdversneller",
                    "unit": "m2",
                    "subcontracting": {
                        "norm": 38
                    }
                }
            ]
        },
        "ZCD 10cm exclusief droogtijdversneller": {
            "items": [
                {
                    "sortOrder": 2,
                    "code": "42.50",
                    "description": "ZCD 10cm exclusief droogtijdversneller",
                    "unit": "m2",
                    "subcontracting": {
                        "norm": 23
                    }
                }
            ]
        },
        "ZCD 7cm inclusief droogtijdversneller": {
            "items": [
                {
                    "sortOrder": 3,
                    "code": "42.50",
                    "description": "ZCD 7cm inclusief droogtijdversneller",
                    "unit": "m2",
                    "subcontracting": {
                        "norm": 29
                    }
                }
            ]
        },
        "ZCD 7cm exclusief droogtijdversneller": {
            "items": [
                {
                    "sortOrder": 4,
                    "code": "42.50",
                    "description": "ZCD 7cm exclusief droogtijdversneller",
                    "unit": "m2",
                    "subcontracting": {
                        "norm": 18
                    }
                }
            ]
        },
        "ZCD 5cm inclusief droogtijdversneller": {
            "items": [
                {
                    "sortOrder": 5,
                    "code": "42.50",
                    "description": "ZCD 5cm inclusief droogtijdversneller",
                    "unit": "m2",
                    "subcontracting": {
                        "norm": 23
                    }
                }
            ]
        },
        "ZCD 5cm exclusief droogtijdversneller": {
            "items": [
                {
                    "sortOrder": 6,
                    "code": "42.50",
                    "description": "ZCD 5cm exclusief droogtijdversneller",
                    "unit": "m2",
                    "subcontracting": {
                        "norm": 15
                    }
                }
            ]
        }
    },
    "44 Plafond- en wandsystemen": {
        "Systeemplafond - Minerale plafondplaat 600x600": {
            "items": [
                {
                    "sortOrder": 1,
                    "code": "44.35",
                    "description": "Systeemplafond - Minerale plafondplaat 600x600",
                    "unit": "m2",
                    "hours": {
                        "norm": 0.4
                    },
                    "material": {
                        "norm": 19
                    }
                },
                {
                    "sortOrder": 2,
                    "code": "44.35",
                    "description": "- API 24 systeem, plaatmaat 600x600, kanthout zwart systeem wit"
                },
                {
                    "sortOrder": 3,
                    "code": "44.35",
                    "description": "- Rockfon Krios, 600x600"
                }
            ]
        },
        "Systeemplafond - Minerale plafondplaat 600x1200": {
            "items": [
                {
                    "sortOrder": 4,
                    "code": "44.35",
                    "description": "Systeemplafond - Minerale plafondplaat 1200x600",
                    "unit": "m2",
                    "hours": {
                        "norm": 0.35
                    },
                    "material": {
                        "norm": 24
                    }
                },
                {
                    "sortOrder": 5,
                    "code": "44.35",
                    "description": "- API 24 systeem, plaatmaat 600x1200, kanthout zwart systeem wit"
                },
                {
                    "sortOrder": 6,
                    "code": "44.35",
                    "description": "- Rockfon Blanka, 600x1200"
                }
            ]
        },
        "Systeemplafond - Gipsvinyl plafondplaat 600x600": {
            "items": [
                {
                    "sortOrder": 7,
                    "code": "44.35",
                    "description": "Systeemplafond - Gipsvinyl 600x600",
                    "unit": "m2",
                    "hours": {
                        "norm": 0.4
                    },
                    "material": {
                        "norm": 18
                    }
                },
                {
                    "sortOrder": 8,
                    "code": "44.35",
                    "description": "- API 24 systeem, plaatmaat 600x600, kanthout zwart systeem wit"
                },
                {
                    "sortOrder": 9,
                    "code": "44.35",
                    "description": "- Witte gipsvinyl plafondplaat 600x600, waterbestendig en afneembaar"
                }
            ]
        },
        "Spotgat rond inclusief achterhout in systeemplafond": {
            "items": [
                {
                    "sortOrder": 10,
                    "code": "44.35",
                    "description": "Ronde spotgatsparing met achterhout",
                    "unit": "stk",
                    "hours": {
                        "norm": 0.15
                    },
                    "material": {
                        "norm": 4
                    }
                }
            ]
        },
        "Plagyp D - Gipsplafond [enkel beplaat]": {
            "items": [
                {
                    "sortOrder": 11,
                    "code": "44.37",
                    "description": "Enkel beplaat gipsplafond",
                    "unit": "m2",
                    "hours": {
                        "norm": 0.8
                    },
                    "material": {
                        "norm": 18
                    }
                },
                {
                    "sortOrder": 12,
                    "code": "44.37",
                    "description": "- Plagyp-D systeem met enkel beplaat 4AK gipsplafond exclusief isolatie"
                },
                {
                    "sortOrder": 13,
                    "code": "44.37",
                    "description": "- exclusief klasse B afwerken"
                }
            ]
        },
        "Plagyp D - Gipsplafond [dubbel beplaat]": {
            "items": [
                {
                    "sortOrder": 14,
                    "code": "44.37",
                    "description": "Dubbel beplaat gipsplafond",
                    "unit": "m2",
                    "hours": {
                        "norm": 1
                    },
                    "material": {
                        "norm": 26
                    }
                },
                {
                    "sortOrder": 15,
                    "code": "44.37",
                    "description": "- Plagyp-D systeem met dubbel beplaat 4AK gipsplafond exclusief isolatie"
                },
                {
                    "sortOrder": 16,
                    "code": "44.37",
                    "description": "- exclusief klasse A afwerken"
                }
            ]
        },
        "Spotgat inclusief achterhout in gipsplafond": {
            "items": [
                {
                    "sortOrder": 17,
                    "code": "44.37",
                    "description": "Ronde spotgatsparing met achterhout",
                    "unit": "stk",
                    "hours": {
                        "norm": 0.15
                    },
                    "material": {
                        "norm": 6
                    }
                }
            ]
        },
        "MS 1.75.1.": {
            "items": [
                {
                    "sortOrder": 18,
                    "code": "44.41",
                    "description": "MS Scheidingswand MS 1.75.1 ex iso",
                    "unit": "m2",
                    "hours": {
                        "norm": 0.75
                    },
                    "material": {
                        "norm": 13
                    }
                },
                {
                    "sortOrder": 19,
                    "code": "44.41",
                    "description": "- opbouw, gips 12,5mm, blik 75mm, gips 12,5mm"
                }
            ]
        },
        "MS1.75.1.A": {
            "items": [
                {
                    "sortOrder": 20,
                    "code": "44.41",
                    "description": "MS Scheidingswand MS 1.75.1.A incl. iso",
                    "unit": "m2",
                    "hours": {
                        "norm": 0.85
                    },
                    "material": {
                        "norm": 17
                    }
                },
                {
                    "sortOrder": 21,
                    "code": "44.41",
                    "description": "- opbouw, gips 12,5mm, blik 75mm, 60mm glaswol, gips 12,5mm"
                }
            ]
        },
        "MS2.75.2": {
            "items": [
                {
                    "sortOrder": 22,
                    "code": "44.41",
                    "description": "MS Scheidingswand MS2.75.2. ex iso",
                    "unit": "m2",
                    "hours": {
                        "norm": 0.95
                    },
                    "material": {
                        "norm": 21
                    }
                },
                {
                    "sortOrder": 23,
                    "code": "44.41",
                    "description": "- opbouw, 2x gips 12,5mm, blik 75mm, 2x gips 12,5mm"
                }
            ]
        },
        "MS2.75.2.A": {
            "items": [
                {
                    "sortOrder": 24,
                    "code": "44.41",
                    "description": "MS Scheidingswand MS2.75.2.A incl. iso",
                    "unit": "m2",
                    "hours": {
                        "norm": 1.05
                    },
                    "material": {
                        "norm": 25
                    }
                },
                {
                    "sortOrder": 25,
                    "code": "44.41",
                    "description": "- opbouw, 2x gips 12,5mm, blik 75mm, 60mm glaswol, 2x gips 12,5mm"
                }
            ]
        },
        "MS2.75.2.A [volledig 2-zijdig achterhout]": {
            "items": [
                {
                    "sortOrder": 26,
                    "code": "44.41",
                    "description": "MS Scheidingswand MS2.75.2.A incl. iso, volledig achterhout",
                    "unit": "m2",
                    "hours": {
                        "norm": 1.35
                    },
                    "material": {
                        "norm": 31
                    }
                },
                {
                    "sortOrder": 27,
                    "code": "44.41",
                    "description": "- opbouw, 1x gips 12,5mm, 1x OSB11mm, blik 75mm, 60mm glaswol, 1x OSB 11m, 1x gips 12,5mm"
                }
            ]
        },
        "MSV 1.75": {
            "items": [
                {
                    "sortOrder": 28,
                    "code": "44.41",
                    "description": "MS Voorzetwand MSV 1.75",
                    "unit": "m2",
                    "hours": {
                        "norm": 0.55
                    },
                    "material": {
                        "norm": 9
                    }
                },
                {
                    "sortOrder": 29,
                    "code": "44.41",
                    "description": "- opbouw 1x gips 12,5mm en blik 75mm"
                }
            ]
        },
        "MSV 1.75.A": {
            "items": [
                {
                    "sortOrder": 30,
                    "code": "44.41",
                    "description": "MS Voorzetwand MSV 1.75.A geisoleerd",
                    "unit": "m2",
                    "hours": {
                        "norm": 0.7
                    },
                    "material": {
                        "norm": 13
                    }
                },
                {
                    "sortOrder": 31,
                    "code": "44.41",
                    "description": "- opbouw 1x gips 12,5mm, blik 75mm, 60mm glaswol"
                }
            ]
        },
        "MSV 2.75 [volledig 1-zijdig achterhout]": {
            "items": [
                {
                    "sortOrder": 32,
                    "code": "44.41",
                    "description": "MS Voorzetwand MSV 2.75 incl. achterhout excl. iso",
                    "unit": "m2",
                    "hours": {
                        "norm": 0.85
                    },
                    "material": {
                        "norm": 16
                    }
                },
                {
                    "sortOrder": 33,
                    "code": "44.41",
                    "description": "- opbouw 1x gips 12,5mm, 1x OSB 11mm, blik 75mm"
                }
            ]
        },
        "MSV 2.75.A [volledig 1-zijdig achterhout en isolatie]": {
            "items": [
                {
                    "sortOrder": 34,
                    "code": "44.41",
                    "description": "MS Voorzetwand MSV 2.75.A incl. achterhout incl. iso",
                    "unit": "m2",
                    "hours": {
                        "norm": 1
                    },
                    "material": {
                        "norm": 20
                    }
                },
                {
                    "sortOrder": 35,
                    "code": "44.41",
                    "description": "- opbouw 1x gips 12,5mm, 1x OSB 11mm, blik 75mm, 60mm glaswol"
                }
            ]
        },
        "Inwerken inbouwreservoir": {
            "items": [
                {
                    "sortOrder": 36,
                    "code": "44.41",
                    "description": "Inwerken inbouwreservoir",
                    "unit": "",
                    "hours": {
                        "norm": 1.5
                    },
                    "material": {
                        "norm": 80
                    }
                }
            ]
        },
        "Inwerken zij-aansluiting houten kozijnen (per set)": {
            "items": [
                {
                    "sortOrder": 37,
                    "code": "44.41",
                    "description": "Inwerken zij-aansluiting houten kozijnen (per set)",
                    "unit": "stk",
                    "hours": {
                        "norm": 0.1
                    },
                    "material": {
                        "norm": 10
                    }
                }
            ]
        },
        "Inwerken neggekanten bij glaswandaansluitingen": {
            "items": [
                {
                    "sortOrder": 38,
                    "code": "44.41",
                    "description": "Inwerken neggekanten bij glaswandaansluitingen",
                    "unit": "m1",
                    "hours": {
                        "norm": 0.3
                    },
                    "material": {
                        "norm": 5
                    }
                }
            ]
        },
        "Inwerken stucstop eindprofielen": {
            "items": [
                {
                    "sortOrder": 39,
                    "code": "44.41",
                    "description": "Inwerken stucstop eindprofielen",
                    "unit": "m1",
                    "hours": {
                        "norm": 0.3
                    },
                    "material": {
                        "norm": 4
                    }
                }
            ]
        },
        "Toeslag RF brandwerend gips": {
            "items": [
                {
                    "sortOrder": 40,
                    "code": "44.41",
                    "description": "Meerprijs 12mm RF t.o.v. standaard 2AK gips",
                    "unit": "m2",
                    "material": {
                        "norm": 3
                    }
                }
            ]
        },
        "Toeslag WR waterwerend gips": {
            "items": [
                {
                    "sortOrder": 41,
                    "code": "44.41",
                    "description": "Meerprijs 12mm RF t.o.v. standaard 2AK gips",
                    "unit": "m2",
                    "material": {
                        "norm": 4
                    }
                }
            ]
        },
        "Toeslag 4AK gipsplaten": {
            "items": [
                {
                    "sortOrder": 42,
                    "code": "44.41",
                    "description": "Meerprijs 12mm 4AK t.o.v. standaard 2AK gips",
                    "unit": "m2",
                    "material": {
                        "norm": 4
                    }
                }
            ]
        }
    },
    "45 Afbouwtimmerwerk": {
        "Leveren en aanbrengen standaard hardhouten plinten 12*55": {
            "items": [
                {
                    "sortOrder": 1,
                    "code": "45.41",
                    "description": "Hardhouten plint 12*55",
                    "unit": "m1",
                    "hours": {
                        "norm": 0.12
                    },
                    "material": {
                        "norm": 3
                    }
                }
            ]
        },
        "Leveren en aanbrengen standaard MDF plinten 12*55": {
            "items": [
                {
                    "sortOrder": 2,
                    "code": "45.41",
                    "description": "MDF gegronde plinten 12*55",
                    "unit": "m1",
                    "hours": {
                        "norm": 0.12
                    },
                    "material": {
                        "norm": 2
                    }
                }
            ]
        },
        "Architraven rondom deuren": {
            "items": [
                {
                    "sortOrder": 3,
                    "code": "45.41",
                    "description": "MDF gegronde architraven",
                    "unit": "m1",
                    "hours": {
                        "norm": 0.1
                    },
                    "material": {
                        "norm": 2
                    }
                }
            ]
        }
    },
    "46 Schilderwerk": {
        "Texwerk licht": {
            "items": [
                {
                    "sortOrder": 1,
                    "code": "46.00",
                    "description": "Texwerk licht",
                    "unit": "m2",
                    "subcontracting": {
                        "norm": 9.2
                    }
                }
            ]
        },
        "Texwerk donker": {
            "items": [
                {
                    "sortOrder": 2,
                    "code": "46.00",
                    "description": "Texwerk donker",
                    "unit": "m2",
                    "subcontracting": {
                        "norm": 10.9
                    }
                }
            ]
        },
        "Schilderen binnendeurkozijn / deur 2-zijdig": {
            "items": [
                {
                    "sortOrder": 3,
                    "code": "46.00",
                    "description": "Schilderen binnendeurkozijn / deur 2-zijdig",
                    "unit": "stk",
                    "subcontracting": {
                        "norm": 190
                    }
                }
            ]
        },
        "Plinten laag": {
            "items": [
                {
                    "sortOrder": 4,
                    "code": "46.00",
                    "description": "Aflakken plinten laag",
                    "unit": "m1",
                    "subcontracting": {
                        "norm": 5.3
                    }
                }
            ]
        }
    },
    "48 Behangwerk, vloerbedekking en stoffering": {
        "Schuren en Stofzuigen ondergrond": {
            "items": [
                {
                    "sortOrder": 1,
                    "code": "48.23",
                    "description": "Schuren en Stofzuigen ondergrond",
                    "unit": "m2",
                    "subcontracting": {
                        "norm": 2
                    }
                }
            ]
        },
        "Schuren en egaliseren 2-3mm ondergrond": {
            "items": [
                {
                    "sortOrder": 2,
                    "code": "48.23",
                    "description": "Schuren en egaliseren 2-3mm ondergrond",
                    "unit": "m2",
                    "subcontracting": {
                        "norm": 12
                    }
                }
            ]
        },
        "Afdekken nieuwe vloerafwerking met stucloper": {
            "items": [
                {
                    "sortOrder": 3,
                    "code": "48.28",
                    "description": "Afdekken nieuwe vloerafwerking met stucloper",
                    "unit": "m2",
                    "hours": {
                        "norm": 0.04
                    },
                    "material": {
                        "norm": 1
                    }
                }
            ]
        },
        "Tapijttegels 500x500": {
            "items": [
                {
                    "sortOrder": 4,
                    "code": "48.44",
                    "description": "Leveren en aanbrengen tapijttegels",
                    "unit": "m2",
                    "subcontracting": {
                        "norm": 45
                    }
                }
            ]
        },
        "PVC standaard wildverband": {
            "items": [
                {
                    "sortOrder": 5,
                    "code": "48.44",
                    "description": "Leveren en aanbrengen PVC wildverband",
                    "unit": "m2",
                    "subcontracting": {
                        "norm": 50
                    }
                }
            ]
        },
        "PVC Visgraat": {
            "items": [
                {
                    "sortOrder": 6,
                    "code": "48.44",
                    "description": "Leveren en aanbrengen PVC Visgraat",
                    "unit": "m2",
                    "subcontracting": {
                        "norm": 55
                    }
                }
            ]
        }
    }
}